import React from "react";
import { useAppDispatch, useAppSelector } from "../../lib/redux/hook";
import { SearchIcon } from "../../ui/icons/searchIcon";
import { ButtonComponent } from "../../ui/molecules/button";
import { InputComponent } from "../../ui/molecules/input";
import { findAllCustomers, setCustomerFilterName } from "./slice";
import { BillowButton } from "../../ui/molecules/billowButton";


export function CustomerFilters() {
    const dispatch = useAppDispatch()
    const customerState = useAppSelector(state => state.customer)

    return (
        <div className={"flex flex-row gap-4 w-full"}>
            <div className={"w-full"}>
                <InputComponent
                    type={"text"}
                    placeholder="Cerca un cliente"
                    startIcon={<SearchIcon />}
                    onChangeText={(value) => dispatch(setCustomerFilterName(value))}
                    value={customerState.customerFilters.name}
                    onKeyDown={e => {
                        if (e.key === "Enter") {
                            dispatch(findAllCustomers({...customerState.customerFilters, itemsPerPage: 0}))
                        }
                    }}
                />
            </div>
            <div className={"gap-4 flex flex-row"}>
                <BillowButton
                    label={"Pulisci"}
                    onClick={() => {
                        dispatch(setCustomerFilterName(""))
                        dispatch(findAllCustomers({
                            page: customerState.customerFilters.page,
                            itemsPerPage: customerState.customerFilters.itemsPerPage,
                            name: "",
                            sort: customerState.customerFilters.sort,
                            sortBy: ""
                        }))
                    }}
                    variant={"outline"}
                    iconPosition={"off"}
                />
                <BillowButton
                    label={"Applica"}
                    onClick={() => {
                        dispatch(findAllCustomers({
                            page: customerState.customerFilters.page,
                            itemsPerPage: 0,
                            name: customerState.customerFilters.name,
                            sort: customerState.customerFilters.sort,
                            sortBy: ""
                        }))
                    }}
                    variant={"solid"}
                    iconPosition={"off"}
                />
            </div>
        </div>
    )
}